import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { workClient } from "../clients/workClient";

const workOrderNamedLookupSchema = z.object({
  id: z.number().int().positive(),
  code: z.string(),
  name: z.string(),
});

const workOrderPriorityLookupSchema = workOrderNamedLookupSchema.extend({
  order: z.number().int().nonnegative().nullable(),
});

const workOrderLookupsResponseSchema = z.object({
  origins: z.array(workOrderNamedLookupSchema),
  priorities: z.array(workOrderPriorityLookupSchema),
  statuses: z.array(workOrderNamedLookupSchema),
  workOrderTypes: z.array(workOrderNamedLookupSchema),
  plannerGroups: z.array(workOrderNamedLookupSchema),
});

export type WorkOrderOriginLookup = z.infer<typeof workOrderNamedLookupSchema>;
export type WorkOrderPriorityLookup = z.infer<
  typeof workOrderPriorityLookupSchema
>;
export type WorkOrderNamedLookup = z.infer<typeof workOrderNamedLookupSchema>;
export type WorkOrderLookupsResponse = z.infer<
  typeof workOrderLookupsResponseSchema
>;

async function fetchWorkOrderLookups(): Promise<WorkOrderLookupsResponse> {
  const response = await workClient.v1["work-order-lookups"].$get();
  if (!response.ok) {
    throw new Error(`Failed to fetch work-order lookups: ${response.status}`);
  }

  return workOrderLookupsResponseSchema.parse(await response.json());
}

export function useWorkOrderLookupsQuery() {
  return useQuery({
    queryKey: ["work-order-lookups"],
    queryFn: fetchWorkOrderLookups,
    meta: { errorMessage: "Failed to load work-order filters." },
  });
}
